import { Card, Chip, Typography } from '@mui/material';

function DecisionsReportTable({ data, loading, lastFilter }) {
    if (data.length > 0) {
        return (
            <Card sx={{ padding: 2, marginTop: 2 }}>
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px', marginBottom: 16 }}>
                    <Typography variant="h6" sx={{ textAlign: 'center' }}>
                        Kararlar
                    </Typography>
                    <Chip
                        label={`Toplam: ${data.length}`}
                        color="primary"
                        size="small"
                        sx={{ fontWeight: 'bold' }}
                    />
                </div>
                <table style={{ width: '100%', borderCollapse: 'collapse', tableLayout: 'fixed' }}>
                    <colgroup>
                        <col style={{ width: '5%' }} />
                        <col style={{ width: '18%' }} />
                        <col style={{ width: '13%' }} />
                        <col style={{ width: '9%' }} />
                        <col style={{ width: '11%' }} />
                        <col style={{ width: '44%' }} />
                    </colgroup>
                    <thead>
                        <tr style={{ backgroundColor: '#f5f5f5' }}>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Sıra</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Toplantı</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Tarihi</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Karar Sayısı</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Konusu</th>
                            <th style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>Karar</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((item, index) => (
                            <tr key={item.id}>
                                <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                                    {index + 1}
                                </td>
                                <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                                    {item.meetingInfo || ''}
                                </td>
                                <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                                    {item.meetingDate ? new Date(item.meetingDate).toLocaleDateString('tr-TR') : ''}
                                </td>
                                <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                                    {item.decisionNo || ''}
                                </td>
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                    {item.subjectName}
                                </td>
                                <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                                    {item.decision ? item.decision.replace(/<[^>]*>/g, '') : ''}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </Card>
        );
    }

    if (!loading && lastFilter) {
        return (
            <Card sx={{ padding: 2, marginTop: 2 }}>
                <Typography align="center" variant="h6">
                    Sonuç Bulunamadı
                </Typography>
            </Card>
        );
    }

    return null;
}

export default DecisionsReportTable;
